export default {
    isFetching: false,
    isRequesting: false,
    pickups: [],
    pickup: {
    }
};
